// extracted by mini-css-extract-plugin
export var active = "_43-7";
export var container = "_43-0";
export var evenWidth = "_43-4";
export var large = "_43-5";
export var outlet = "_43-8";
export var slide = "_43-2";
export var small = "_43-6";
export var tab = "_43-3";
export var tabs = "_43-1";